import type { GetStaticProps, NextPage } from "next";
import Image from "next/image";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CSSTransition } from "react-transition-group";
import { BlogApi } from "../api/api";
import PopupBlog from "../components/PopupBlog";
import { getCurrentLocale } from "../i18n";
import { IBlog } from "../utils/types";

interface BlogProps {
  primaryBlogList: Array<IBlog> | null;
  blogList: Array<IBlog> | null;
}

const Blog: NextPage<BlogProps> = ({ primaryBlogList, blogList }) => {
  const { t } = useTranslation();
  const currentLocale = getCurrentLocale();
  const [isOpen, setIsOpen] = useState(false);
  const [currentBlog, setCurrentBlog] = useState<IBlog | null>(null);

  return (
    <main className="container">
      <div className="sitebar-left">
        <div className="page-title services">
          {primaryBlogList?.length === 0 ? (
            <div className="no-posts">
              <p>{t("blog:emptyList")}</p></div>
          ) : (
            <h2>{t("navigation:blog")}</h2>
          )}
        </div>
      </div>
      {primaryBlogList?.length !== 0 && (
        <>
          <div className="container-content  blog portfolio">
            <div className="row">
              <div className="content">
                <div className="row primary">
                  {primaryBlogList?.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => setCurrentBlog(item)}
                      className="blog-primary"
                    >
                      <div className="blog-img">
                        {/* <Image
                      layout="fill"
                      src={item.image}
                      alt={currentLocale === "en" ? item.name_en : item.name}
                    /> */}
                        <img
                          src={item.image}
                          alt={
                            currentLocale === "en" ? item.name_en : item.name
                          }
                        />
                      </div>
                      <h3 className="blog-title">
                        {currentLocale === "en" ? item.name_en : item.name}
                      </h3>
                      <p className="blog-text">
                        {currentLocale === "en" ? item.text_en : item.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="content grid">
                {blogList?.map((item) => {
                  return (
                    <div
                      key={item.id}
                      onClick={() => {
                        setIsOpen(true);
                        setCurrentBlog(item);
                      }}
                    >
                      <div className="project">
                        <div className="project-img">
                          {/* <Image width={'100%'} height={'100%'} src={item.image} alt={item.name_en} /> */}
                          {/* <Image
                      layout="fill"
                      src={item.image}
                      alt={currentLocale === "en" ? item.name_en : item.name}
                      /> */}
                          <img
                            src={item.image}
                            alt={
                              currentLocale === "en" ? item.name_en : item.name
                            }
                          />
                        </div>
                        <h4 className="project-title">
                          {currentLocale === "en" ? item.name_en : item.name}
                        </h4>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="sitebar-right"></div>
          <CSSTransition
            in={!!currentBlog}
            timeout={{ enter: 500, exit: 500, appear: 500 }}
            classNames={"smooth"}
            unmountOnExit
          >
            <PopupBlog
              blog={currentBlog}
              onClose={() => setCurrentBlog(null)}
            />
          </CSSTransition>
        </>
      )}
      {/* {currentBlog && (
        <PopupBlog blog={currentBlog} onClose={() => setCurrentBlog(null)} />
      )} */}
    </main>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const list = await BlogApi.getBlogList()
  const primaryBlogList = list?.splice(0, 2);
  return { props: { primaryBlogList, blogList: list }, revalidate: 10 };
};

export default Blog;
